<template>
  <b-nav-item-dropdown
    v-if="files.length > 0 && instructives.length > 0"
    right
    class="profileDd"
  >
    <template slot="button-content">
      <em><b-icon icon="question-circle"></b-icon></em>
    </template>
    <b-dropdown-item
      v-for="instructive in instructives"
      :key="instructive.id"
      @click="downloadFile(instructive.file)"
      href="#"
    >
      <b-icon-book class="mr-2"></b-icon-book>{{ instructive.name }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { downloadFileByUrl } from "@/utils/utils";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      isLoged: "isLoged",
      files: names.FILES,
      instructives: names.INSTRUCTIVES,
    }),
  },
  methods: {
    downloadFile(file_id) {
      this.$store
        .dispatch(names.FETCH_FILE, file_id)
        .then((file) => {
          if (file) {
            if (file.file != null) {
              downloadFileByUrl(file.file);
            }
          }
        });
    },
  },
  watch: {},
  created() {
    if (this.isLoged) {
      this.$store.dispatch(names.FETCH_INSTRUCTIVES).then((response) => {
        response.forEach((instructive) => {
          this.$store.dispatch(names.FETCH_FILE, instructive.file);
        });
      });
    }
  },
};
</script>

<style>
</style>